/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Unsaved_DescInputs */

const en_dialog_text_to_audio_unsaved_desc = /** @type {(inputs: Dialog_Text_To_Audio_Unsaved_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have text in the editor that hasn't been converted yet. If you leave now, all your content will be lost.`)
};

const es_dialog_text_to_audio_unsaved_desc = /** @type {(inputs: Dialog_Text_To_Audio_Unsaved_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienes texto en el editor que todavía no se ha convertido. Si sales ahora, perderás todo el contenido.`)
};

/**
* | output |
* | --- |
* | "You have text in the editor that hasn't been converted yet. If you leave now, all your content will be lost." |
*
* @param {Dialog_Text_To_Audio_Unsaved_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_unsaved_desc = /** @type {((inputs?: Dialog_Text_To_Audio_Unsaved_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Unsaved_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_unsaved_desc(inputs)
	return en_dialog_text_to_audio_unsaved_desc(inputs)
});